import { GetterTree } from 'vuex';

import { RootState, ListStatus } from '@/store/types';
import { createEditableGetters } from '@/store/utils/editable';

import { RegionsState } from './types';

const {
  isLoading: editableIsLoading,
  isLoaded: editableIsLoaded,
  isSaving: editableIsSaving,
  isSaved: editableIsSaved,
  isFailed: editableIsFailed,
  isFetching: editableIsFetching,
  hasUnsavedChanges: editableHasUnsavedChanges,
} = createEditableGetters<RegionsState>('editableStatus', 'editable', 'initialEditable');

export const moduleGetters: GetterTree<RegionsState, RootState> = {
  /**
   * Edit
   */
  editableIsLoading,
  editableIsLoaded,
  editableIsSaving,
  editableIsSaved,
  editableIsFailed,
  editableHasUnsavedChanges,
  editableIsFetching,
};

export default moduleGetters;
